import React from 'react';

import DatePicker from 'react-datepicker';
import { getMonth, getYear } from 'date-fns';
import range from 'lodash/range';
import SelectComponent from '../../common/AutoSuggestSelect/Select';
import { MONTHS_KEY_VALUE } from 'src/constants';
import 'react-datepicker/dist/react-datepicker.css';
import {
  PickerRightArrow,
  PickerLeftArrow,
  CalendarIcon,
} from './PickerSvgImages';

import './datepicker.scss';
import { useSelector } from 'react-redux';

const DatePickerComponent = (props) => {
  const {
    value,
    onChange,
    className,
    maxYearRange = 10,
    placeholder,
    allowFutureDates,
    isDOB,
    ...restProps
  } = props;

  const futureYear = allowFutureDates ? 10 : 1;

  const finalMaxYearRange = isDOB ? 100 : maxYearRange;
  const years = range(
    getYear(new Date()) - finalMaxYearRange,
    getYear(new Date()) + futureYear,
    1,
  );
  const months = [...MONTHS_KEY_VALUE];

  const yearsArray = years.map((m) => {
    return { label: m, value: m };
  });

  const { Default_Time_Format } = useSelector(
    ({ app }) => app.appConfigs.Time_Setting || 'MM-dd-yyyy',
  );
  //alert(Default_Time_Format);
  const dtFormat =
    Default_Time_Format === 'MM-DD-YYYY'
      ? 'MM-dd-yyyy'
      : Default_Time_Format === 'DD-MM-YYYY'
      ? 'dd-MM-yyyy'
      : Default_Time_Format === 'YYYY-MM-DD'
      ? 'yyyy-MM-dd'
      : Default_Time_Format || 'MM-dd-yyyy';

  return (
    <div
      className={`${
        props.disabled ? 'picker-disabled' : ''
      } datepicker-container`}
    >
      <DatePicker
        formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 3)}
        //customInput={
        //<CustomInput placeholder={placeholder || dtFormat.toUpperCase()} />
        //}
        dateFormat={dtFormat}
        autoComplete="off"
        dateFormatCalendar={dtFormat}
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div
            style={{
              margin: 7,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <button
              className="left-button"
              type={'button'}
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
            >
              <PickerLeftArrow />
            </button>

            <SelectComponent
              options={yearsArray}
              components={{ IndicatorSeparator: () => null }}
              inputClassName="best-match-filter height-32 year-dropdown"
              value={{
                label: getYear(date),
                value: getYear(date),
              }}
              onChange={(e) => changeYear(e.value)}
              isSearchable={false}
            />

            <SelectComponent
              options={months}
              components={{ IndicatorSeparator: () => null }}
              inputClassName="best-match-filter height-32 month-dropdown"
              value={months[getMonth(date)]}
              onChange={(e) =>
                changeMonth(months.map((o) => o.value).indexOf(e.value))
              }
              isSearchable={false}
            />

            <button
              className="right-button"
              type={'button'}
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
            >
              <PickerRightArrow />
            </button>
          </div>
        )}
        selected={value}
        maxDate={allowFutureDates ? null : new Date()}
        minDate={new Date('01-01-' + yearsArray[0].value)}
        placeholderText={placeholder || dtFormat.toUpperCase()}
        onChange={onChange}
        className={
          restProps.errorClassName ? restProps.errorClassName : className
        }
        onBlur={restProps.onBlur}
        {...restProps}
        popperModifiers={[
          {
            name: 'arrow',
            options: { padding: 24 },
          },
        ]}
        aria-required={restProps.ariaRequired}
        aria-invalid={restProps.ariaInvalid}
        aria-describedby={restProps.ariaDescribedby}
      />
      {restProps.showIcon && (
        <span className="datepicker-icon">
          <CalendarIcon />
        </span>
      )}
    </div>
  );
};

export default DatePickerComponent;
